var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.44444 33.3333V40H11.1111V33.3333H33.3333V40H40V26.6667H4.44444V33.3333ZM37.7778 15.5556H44.4444V22.2222H37.7778V15.5556ZM0 15.5556H6.66667V22.2222H0V15.5556ZM33.3333 22.2222H11.1111V4.44444C11.1111 3.2657 11.5794 2.13524 12.4129 1.30175C13.2464 0.468252 14.3768 0 15.5556 0H28.8889C30.0676 0 31.1981 0.468252 32.0316 1.30175C32.8651 2.13524 33.3333 3.2657 33.3333 4.44444V22.2222Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarChair);
export default __webpack_public_path__ + "static/media/sidebar_chair.e602296235298efdda599f659789dd62.svg";
export { ForwardRef as ReactComponent };